import React from 'react';
import CustomDialog, {
  CustomDialogProps,
} from '../../../../../components/CustomDialog/index';
import MedicalCertificatesTable from '../../../../../components/MedicalCertificatesTable';

const MedicalCertificatesDialog: React.FC<CustomDialogProps> = ({
  open,
  handleClose,
  handleConfirm,
}) => {
  return (
    <CustomDialog
      open={open}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      title="Atestados"
      contentDividers
      showCloseButton
      maxWidth="lg"
      fullWidth={false}
      keepMounted={false}
      showOneButton
    >
      <MedicalCertificatesTable />
    </CustomDialog>
  );
};
export default MedicalCertificatesDialog;
